export enum Period {
  hours = 1,
  days = 3,
  LongTerm = 4,
}
